import { GetApiClient } from "@/utils/api-client";
import { getUserApi } from "@/apis/user";
import { AuthState } from "@/atoms/auth";
import { ForbiddenError } from "@/@types/api-error";

export class AuthSessionUsecase {
  static async currentAuthState(apiClient: GetApiClient): Promise<AuthState> {
    try {
      const user = await getUserApi(apiClient);
      return { type: "LoggedIn", user };
    } catch (e) {
      if (e instanceof ForbiddenError) {
        return { type: "Forbidden" };
      }
      return { type: "NotLogin" };
    }
  }
}
